import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { GreenText } from 'components'
import { OutboundTripDetailNotesDto } from 'dtos/outboundTrips'
import { Form, Formik } from 'formik'
import { OutboundTripDetailNotesDtoValidator } from 'validators/outboundTrips'

interface NotesDialogProps {
  initialValues: OutboundTripDetailNotesDto
  isLoading: boolean
  onClose: () => void
  onSave: (values: OutboundTripDetailNotesDto) => void
  open: boolean
}

export default function NotesDialog({ initialValues, isLoading, onClose, onSave, open }: NotesDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={values => onSave(values)}
        validateOnBlur={false}
        validateOnChange={true}
        validationSchema={OutboundTripDetailNotesDtoValidator}
      >
        {({ errors, handleBlur, handleChange, values }) => {
          return (
            <Form>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Notes</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading}
                      error={Boolean(errors.internalNotes)}
                      fullWidth
                      helperText={errors.internalNotes}
                      label='Internal Notes'
                      maxRows={4}
                      minRows={4}
                      multiline
                      name='internalNotes'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.internalNotes || ''}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading}
                      error={Boolean(errors.externalNotes)}
                      fullWidth
                      helperText={errors.externalNotes}
                      label='Outbound Bill Of Lading Notes'
                      maxRows={4}
                      minRows={4}
                      multiline
                      name='externalNotes'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.externalNotes || ''}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <GreenText variant='outlined'>
                      {`**Internal Notes:**

A free-text field.

Internal notes are only displayed on this screen and the “To Do Lists” related to 
Outbound Trips.

**Outbound Bill Of Lading Notes:**

A free-text field.

Outbound Bill of Lading Notes will appear on the Outbound Bill Of Lading Itself`}
                    </GreenText>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' disabled={isLoading} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
